<p-fieldset>
    <ng-template pTemplate="header">{{dataTitle}}
        <ng-content select="dm-fieldset-button"></ng-content>    
        </ng-template>
        <ng-content select="dm-fieldset-header"></ng-content>            
    <ng-content></ng-content>
</p-fieldset>
